/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import DesktopHeaderContent from './DesktopHeaderContent';
import DesktopHeaderLogo from './DesktopHeaderLogo';
import {HeaderProps} from './MobileHeader';
import styles from './DesktopHeader.module.scss';

/**
 * The Desktop Header component provides the application Header  when view in
 * Desktop Mode.
 */
export const DesktopHeader = ({
  username,
  onHelp,
  onLogout,
  isLoggingOut,
  isSelected
}: HeaderProps) => {
  return (
    <div className={styles.container}>
      <DesktopHeaderLogo />
      <div className={styles.search} style={{flexGrow: 8}}>
        <div style={{width: 421, display: 'inline-flex', marginLeft: 130}} />
      </div>
      <DesktopHeaderContent username={username}
        onLogout={onLogout}
        onHelp={onHelp}
        isLoggingOut={isLoggingOut}
        isSelected={isSelected} />
    </div>
  );
};

export default DesktopHeader;
